import React from 'react';
import './HowItWorks.css';

const HowItWorks = () => {
  const steps = [
    {
      icon: 'flaticon-route',
      title: 'Select Pick-up & Destination',
      description: 'Choose your pick-up and drop-off locations with ease. We ensure a smooth start and a hassle-free delivery!'
    },
    {
      icon: 'flaticon-select',
      title: 'Select Term',
      description: 'Pick the shipping terms that best fit your needs. Flexible options to match your schedule and budget!'
    },
    {
      icon: 'flaticon-rent',
      title: 'Choose Open/Closed Transport',
      description: "Select open transport for affordability or enclosed for extra protection. Your vehicle, your choice – we've got you covered!"
    },
    {
      icon: 'flaticon-review',
      title: 'Enjoy The Shipping',
      description: 'Relax while we handle the transport with care and precision. Reliable service, on-time delivery – satisfaction guaranteed!'
    }
  ];

  return (
    <section className="ftco-section services-section img how-it-works-section">
      <div className="overlay"></div>
      <div className="container">
        <div className="row justify-content-center mb-5">
          <div className="col-md-7 text-center heading-section heading-section-white ftco-animate">
            <span className="subheading">Work flow</span>
            <h2 className="mb-3">How it works</h2>
          </div>
        </div>
        <div className="row">
          {steps.map((step, index) => (
            <div key={index} className="col-md-3 d-flex align-self-stretch ftco-animate">
              <div className="media block-6 services services-2">
                <div className="media-body py-md-4 text-center">
                  <div className="icon d-flex align-items-center justify-content-center">
                    <span className={step.icon}></span>
                  </div>
                  <h3>{step.title}</h3>
                  <p>{step.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;


